import React from "react";
import { BiChevronRight } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { cn } from "../../utils/lib";


interface BreadcrumbItem {
  text: string;
  isActive?: any;
  disable?: boolean;
  href?: string;
  onClick?: any;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  separator?: React.ReactNode;
  className?: string;
}

const Breadcrumb = ({
  items,
  separator = <BiChevronRight className="mx-1 h-4 w-4 text-gray-400" />,
  className = "",
}: BreadcrumbProps) => {
  const navigate = useNavigate();
  return (
    <div
      aria-label="Breadcrumb"
      className={cn(
        "w-fit text-nowrap rounded-md border border-gray-300 p-0.5 text-[12px] 2xl:text-xs",
        className,
      )}
    >
      <ol className="flex flex-wrap items-center">
        {items.map((item, index) => (
          <li
            key={index}
            className="flex items-center"
            aria-current={item.isActive ? "page" : undefined}
          >
            <span
              className={cn(
                "flex items-center rounded-md px-1.5 py-1 font-medium transition-colors",
                item.isActive
                  ? "pointer-events-none cursor-default bg-blue-100 text-primary"
                  : "cursor-pointer border border-transparent text-gray-500",
                item.disable ? "cursor-not-allowed" : "hover:bg-gray-200",
              )}
              onClick={() => {
                if (!item.disable) {
                  if (item.href) navigate(item.href);
                  else item.onClick();
                }
                 else item.onClick();
              }}
            >
              {item.text}
            </span>

            {index < items.length - 1 && separator}
          </li>
        ))}
      </ol>
    </div>
  );
};

export { Breadcrumb };

